// @flow
export default `
  fragment Address on Address {
    streetNumber
    streetName
    additionalInformation1
    additionalInformation2
    addOn
    zipCode
    city
    town
    stateOrDistrict
    country
    countryCode
  }
`;
